'use strict';

class Vector {
    constructor(dx, dy) {
        this.x = dx;
        this.y = dy;
        this.mag = undefined;
        this.head = undefined;
    }

    get copy() {
        return new Vector(this.x, this.y);
    }

    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.mag = undefined;
        this.head = undefined;
        return this;
    }

    subtract(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.mag = undefined;
        this.head = undefined;
        return this;
    }

    scale(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.mag = undefined;
        this.head = undefined;
        return this;
    }

    dot(v) {
        return this.x * v.x + this.y * v.y;
    }

    get magnitude() {
        return this.mag !== undefined ? this.mag : (this.mag = Math.sqrt(this.dot(this)));
    }

    normalize() {
        return this.scale(1 / this.magnitude);
    }

    get heading() {
        return this.head !== undefined ? this.head : (this.head = Math.atan2(this.y, this.x));
    }

    distance(v) {
        let dx = v.x - this.x;
        let dy = v.y - this.y;
        return Math.sqrt(dx * dx + dy * dy);
    }

    limit(lim) {
        if (this.magnitude > lim) {
            this.normalize().scale(lim);
        }
        return this;
    }

    static vectorFromSpeedAndAngle(speed, angle) {
        let angleRadians = angle * Math.PI / 180.0;
        let x = speed * Math.cos(angleRadians);
        let y = speed * Math.sin(angleRadians);

        return new Vector(x, y);
    }
}

const canvas = document.getElementById('fireworks');
const ctx = canvas.getContext('2d');

const GRAVITY = new Vector(0, 0.1);
const MAX_VEL = 8;

let cWidth = canvas.scrollWidth;
let cHeight = canvas.scrollHeight;

let gradient = ctx.createLinearGradient(cWidth / 2, 0, cWidth / 2, cHeight);

let particles = [];
let mortars = [];

function rnd(min = 0, max = 100) {
    return (Math.random() * (max - min)) + min;
}

function rndi(min = 0, max = 100) {
    return Math.floor( (Math.random() * (max - min)) + min );
}

function clamp(value, min = 0, max = 1.0) {
    return Math.max(min, Math.min(max, value));
}

function updateCanvasSize() {
    cWidth = canvas.scrollWidth;
    cHeight = canvas.scrollHeight;

    ctx.canvas.width = cWidth;
    ctx.canvas.height = cHeight;

    gradient = ctx.createLinearGradient(cWidth / 2, 0, cWidth / 2, cHeight);
    gradient.addColorStop(0, '#000000');
    gradient.addColorStop(0.45, '#0c2753');
    gradient.addColorStop(0.65, '#003b76');
    gradient.addColorStop(1.0, '#007b97');
}

function outOfBounds(v) {
    return (v.x < 0 || v.x > cWidth || v.y < 0 || v.y > cHeight);
}

function createParticle(centX, centY, velVect, fillColor, lifeSpan) {
    return {
        pos: new Vector(centX, centY),
        vel: velVect || new Vector(rnd(-MAX_VEL, MAX_VEL), rnd(MAX_VEL, -MAX_VEL)),
        fill: fillColor || `#${ (rndi(100, 255)).toString(16) }${ (rndi(100, 255)).toString(16) }${ (rndi(100, 255)).toString(16) }`,
        life: lifeSpan || 80,
        origLife: lifeSpan || 80
    };
}

function createMortar(cx, cy) {
    let target = new Vector(cx || rndi(cWidth / 3, cWidth / 3 * 2), cy || rndi(cHeight / 4, cHeight / 2));
    let vel = target.subtract(new Vector(cWidth / 2, cHeight));
    vel.normalize().scale(rnd(8, 10));
    return createParticle(cWidth / 2, cHeight, vel, '#00a7fe');
}

function createBurst(qty = 30, cx = cWidth / 2, cy = cHeight / 2) {
    for(let i = 0; i < qty; i++) {
        particles.push(createParticle(cx, cy));
    }
}

function createSpray(qty = 30, cx = cWidth / 2, cy = cHeight / 2) {
    let angle = rnd(250, 290);
    for (let i = 0; i < qty; i++) {
        let a = angle;
        let speed = 1;
        let variance = rnd(0, 100);
        if (variance < 40) {
            a += rnd(-15, 15);
            speed += rnd(1, 5);
        }
        else if (variance < 60) {
            a += rnd(-25, -15);
            speed += rnd(1, 4);
        }
        else if (variance < 80) {
            a += rnd(15, 25);
            speed += rnd(1, 4);
        }
        else if (variance < 90) {
            a += rnd(-35, -25);
            speed += rnd(1, 2);
        }
        else {
            a += rnd(25, 35);
            speed += rnd(1, 2);
        }
        let v = Vector.vectorFromSpeedAndAngle(speed, a);
        particles.push(createParticle(cx, cy, v));
    }
}

function clearCanvas() {
    ctx.save();
    ctx.globalAlpha = 0.33;
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, cWidth, cHeight);
    ctx.restore();
}

function moveAndPaintParticles() {
    if (particles.length === 0) {
        return;
    }

    particles.forEach((p, i) => {
        if (p.life <= 0 || outOfBounds(p.pos)) {
            particles.splice(i, 1);
            return;
        }

        p.vel.add(GRAVITY);
        p.vel.limit(MAX_VEL);
        p.pos.add(p.vel);

        let alpha = clamp(p.life / p.origLife);
        ctx.save();
        ctx.fillStyle = p.fill;
        ctx.globalAlpha = alpha;
        // ctx.fillRect(p.pos.x, p.pos.y, 1, 1);
        ctx.beginPath();
        ctx.arc(p.pos.x, p.pos.y, 2, 0, Math.PI * 2);
        ctx.fill();
        ctx.closePath();
        ctx.restore();

        p.life--;
    });
}

function moveAndPaintMortars() {
    if (mortars.length === 0) {
        return;
    }

    mortars.forEach((p, i) => {

        //If it reaches the point that it's not travelling upwards anymore
        if (p.vel.y > 0) {
            let type = rndi(); //0-100 range
            // 10% chance double burst
            if (type < 10) {
                createBurst(rndi(30, 60), p.pos.x + rndi(-10, 10), p.pos.y + rndi(-10, 10));
                createBurst(rndi(30, 60), p.pos.x + rndi(-10, 10), p.pos.y + rndi(-10, 10));
            }
            else if (type < 20) { // 10% burst and spray
                createBurst(rndi(30, 60), p.pos.x, p.pos.y);
                createSpray(rndi(30, 60), p.pos.x + rndi(-10, 10), p.pos.y + rndi(-10, 10));
            }
            else if (type < 30) { // 10% double spray
                createSpray(rndi(30, 60), p.pos.x + rndi(-10, 10), p.pos.y + rndi(-10, 10));
                createSpray(rndi(30, 60), p.pos.x + rndi(-10, 10), p.pos.y + rndi(-10, 10));
            }
            else if (type < 50) { // 20% single spray, more particles
                createSpray(rndi(50, 80), p.pos.x, p.pos.y);
            }
            else { // 50% regular burst
                createBurst(rndi(30, 60), p.pos.x, p.pos.y);
            }

            mortars.splice(i, 1);
            return;
        }

        p.vel.add(GRAVITY);
        // p.vel.limit(MAX_VEL);
        p.pos.add(p.vel);

        ctx.fillStyle = p.fill;
        ctx.beginPath();
        ctx.arc(p.pos.x, p.pos.y, 3, 0, Math.PI * 2);
        ctx.fill();
        ctx.closePath();
    });
}

function render() {
    clearCanvas();
    moveAndPaintMortars();
    moveAndPaintParticles();
    requestAnimationFrame(render);
}

function launchFirework() {
    if(mortars.length < 4){
        mortars.push(createMortar());
    }
    setTimeout(launchFirework, rndi(200, 800));
}

updateCanvasSize();
window.addEventListener('resize', updateCanvasSize);
canvas.onclick = (evt) => {
    mortars.push(createMortar(evt.clientX, evt.clientY));
};
render();
launchFirework();
